import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { mobile } from 'styles/media';

const wrap: CSSObject = {
  width: '560px',
  maxWidth: '100%',
  display: 'flex',
  flexDirection: 'column',
  '> input, > textarea': { width: '100%' },
};

const readOnlyRow: CSSObject = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px 24px',
};

const readOnlyValue: CSSObject = {
  fontSize: 14,
  color: theme.color.grey600,
};

const imageRow: CSSObject = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '12px 24px',
  marginTop: 8,
};

const footer: CSSObject = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '0 8px',
  marginTop: 24,
  [mobile]: {
    '> button': { flex: 1, height: 48 },
  },
};

export { wrap, readOnlyRow, readOnlyValue, imageRow, footer };
